export const appPayeesList = [
  { payeeName: "Opening Balance" },
  { payeeName: "Balance Adjustment" },
];
